import * as yup from 'yup'

export const MAILBOX_INVALID_MESSAGE = 'מותר להשתמש רק באותיות קטנות באנגלית ובספרות. אפשר להפריד בין מלים עם נקודה או מקף אחד ביניהן, אבל לא בהתחלה או בסוף.'
export const MAILBOX_TOO_LONG_MESSAGE = 'עד 64 תווים'

const MAILBOX_MAX_LENGTH = 64
const MAILBOX_PATTERN = /^[a-z0-9]+(?:[.-][a-z0-9]+)*$/

const schema = yup.object({
    name: yup
        .string()
        .label('שם המשרד')
        .required('נא להזין את שם המשרד')
        .meta({
            section: 'basic',
        }),
    mailbox: yup
        .string()
        .label('תיבת דואר')
        .required('נא להזין את תיבת הדואר')
        .max(MAILBOX_MAX_LENGTH, MAILBOX_TOO_LONG_MESSAGE)
        .matches(MAILBOX_PATTERN, MAILBOX_INVALID_MESSAGE)
        .meta({
            section: 'basic',
            forceLtr: true,
        }),
})

export default schema
